// @flow
import type { PddTicket } from '../types';
import CommonApi from './../commonApi';

const pddTicket = new CommonApi<PddTicket>('pddTicket', 'Билеты ПДД');

export default {
  ...pddTicket
};
